import React from 'react'
import { GroupTitle } from 'src/editor/layout/sidebar/settings/group-title'
import { Repeat04Icon } from 'src/editor/shared/icons/repeat-04-icon'
import {
  ButtonSizeEnum,
  GhostIconButton,
} from 'src/editor/shared/ui-lib/buttons'
import { ButtonHoverInterface } from 'src/shared/schemas/button-hover.schema'
import { ButtonHoverGroup } from '../../styles/ButtonHoverGroup'
import HoverTransformStyle from '../../styles/HoverTransformStyle'

interface HoverButtonSettingProps {
  textColor?: string
  backgroundColor?: string
  subTextColor?: string
  hover?: ButtonHoverInterface
  defaultHover?: ButtonHoverInterface
  mobileDefaultHover?: ButtonHoverInterface
  mobileHover?: ButtonHoverInterface
  update: (hover: ButtonHoverInterface) => void
  mobileUpdate: (hover: ButtonHoverInterface) => void
}

function HoverButtonSetting({
  hover,
  defaultHover,
  mobileDefaultHover,
  mobileHover,
  update,
  mobileUpdate,
  textColor,
  backgroundColor,
  subTextColor,
}: HoverButtonSettingProps) {
  const onResetStyles = () => {
    if (defaultHover) {
      update(defaultHover)
      mobileUpdate(mobileDefaultHover || defaultHover)
    }
  }
  return (
    <>
      <GroupTitle
        afterChildren={
          defaultHover && (
            <GhostIconButton
              size={ButtonSizeEnum.Small}
              onClick={onResetStyles}
              icon={<Repeat04Icon />}
            />
          )
        }
      >
        entity_settings.button.hover_effect.group_title
      </GroupTitle>
      <ButtonHoverGroup
        update={update}
        mobileUpdate={mobileUpdate}
        hover={hover}
        mobileHover={mobileHover}
        backgroundColor={backgroundColor}
        textColor={textColor}
        subTextColor={subTextColor}
      />
      <HoverTransformStyle
        update={update}
        mobileUpdate={mobileUpdate}
        transformHover={hover}
        mobileTransformHover={mobileHover}
      />
    </>
  )
}

export default HoverButtonSetting
